export default {
  hero: {
    badge: "Digital Store",
    titlePrefix: "Products & ",
    titleHighlight: "Offers",
    subtitle: "Courses, digital products, workshops, and services designed to take your business to the next level."
  },
  categories: {
    all: "All",
    courses: "Courses",
    products: "Digital Products",
    workshops: "Workshops",
    services: "Services"
  },
  grid: {
    foundSingle: "product found",
    foundPlural: "products found"
  },
  common: {
    buyNow: "Buy Now",
    enroll: "Enroll",
    book: "Book",
    hire: "Hire",
    new: "New",
    popular: "Popular",
    bestSeller: "Best Seller"
  },
  footerCta: {
    title: "Don't see what you're looking for?",
    subtitle: "Book a free consultation and we'll help you find the perfect solution for your business.",
    cta: "Book Free Consultation"
  },
  items: {
    m1: { badge: "Best Seller", desc: "Learn to create viral content and grow your audience on Instagram, TikTok, and Facebook from scratch." },
    m2: { desc: "Master AI tools to automate your business and multiply your income." },
    m3: { title: "Digital Marketing from Scratch", desc: "Complete course for entrepreneurs who want to learn digital marketing and grow their business." },
    m4: { desc: "Professional content calendar template to plan 30 days of posts." },
    m5: { title: "Complete Brand Kit", desc: "Digital brand kit with Canva templates, color guide, and fonts for your business." },
    m6: { title: "Instagram Captions Pack", desc: "200 ready-to-use Instagram captions that generate engagement and sales for your business." },
    m7: { title: "Workshop: Launch Your Business", badge: "Live", desc: "3-hour live workshop to launch your digital business from scratch with strategy." },
    m8: { desc: "Learn to build your email list and create campaigns that generate automatic sales." },
    m9: { title: "Workshop: Personal Branding", badge: "Upcoming", desc: "Build a powerful personal brand that positions you as an expert in your industry." },
    m10: { title: "1:1 Consulting", desc: "Private 60-minute session to review your digital strategy and create an action plan." },
    m11: { title: "Social Media Management", desc: "Full monthly social media management service with strategy and content." },
    m12: { title: "Website Design", desc: "Professional website design and development on Wix with conversion strategy included." }
  }
};
